import './Generative.css';
import generative from './generative.jpg';    
import Navbar from './Navbar.js';
import Footer from './footer.js';
import video_brain3 from './brain-4.mp4';

const Generative = () => {
  return (
    <div className="Generative-page">
       <Navbar />
       <h1 className='h1_mine'>Cnyda Dynamics Research Division</h1>
      <header className="Generative-hero">
        <div className="Generative-content">
          <h1>Generative AI Research:</h1>
          <p>Working on developing a minimal parameter model for generative AI, as we are aware of the impressive language capabilities of these models.
            To generate high-quality language outputs, we are exploring questions such as: What is the minimum amount of training data required to train a language model? 
            Is there a minimum threshold for the number of parameters that can be used to achieve optimal language performance?
          </p>
           <video 
              src={video_brain3} 
              className="image_Generative" 
              autoPlay 
              loop 
              muted 
              playsInline
            />
        </div>
      </header> 
      <Footer/>
    </div>
  );
};

export default Generative;